module.exports = __webpack_public_path__ + "media/images/back-arrow-484609923cde17d60a7d02a602a2a840.svg";